<!--用户中心-->
<template>
  <div class="user-container">
    <headerIndex/>
    <!--内容部分-->
    <div class="user-content">
      <userinfo :info="info" @attentSuccess="attentSuccess"/>
      <AuthorContent :info="info"/>
    </div>
    <hang/>
    <home_footer/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import userinfo from '@/components/user/index'
import AuthorContent from '@/components/AuthorContent/index'
import Hang from "@/components/Hang/Hang";
import {personal} from '@/api/interfaceApi'
export default {
  name: "index",
  components: {headerIndex, home_footer,userinfo,AuthorContent,Hang},
  data() {
    return {
      height_min: document.documentElement.clientHeight - 275,
      info:{},//作者基本信息
      cid:0,
    }
  },
  methods: {
    // 网络请求 获取作者信息
    personalMethod() {
      personal({bid: this.$route.query.bid, uid:this.cid}).then((res) => {
        if (res.code == 200) {
          this.info = res.content;
        }
      });
    },
    // 点击关注成功后
    attentSuccess() {
      this.personalMethod();
    },
  },
  mounted() {
    // 获取作者基本信息
    this.personalMethod();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>

<style scoped lang="scss">
.user-container {
  background: #F1F1F1;

  .user-content {
    padding: 17px 18%;
    background: #F1F1F1;
    min-width: 76rem;
  }
}
</style>